import React from 'react';
import { Button } from '@wix/design-system';
import classNames from 'classnames';
import s from './ActionButton.scss';
export const ActionButton = ({ dataHook, className, suffixIcon, type, children, onClick, }) => {
    return (React.createElement(Button, { skin: "dark", priority: "secondary", dataHook: dataHook, suffixIcon: suffixIcon, type: type, className: classNames(s.actionButton, className), onClick: onClick }, children));
};
//# sourceMappingURL=ActionButton.js.map